import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Tooltip,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileAPI from "../../services/UploadFileService";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import useLocales from "../../hooks/useLocales";
import { useData } from "../../contexts/DataContext";
import { isValidResponse } from "../../hooks/useAxiosPrivate";
import { axiosPrivate } from "../../services/axios";
import TimeSheetAPI from "../../services/TimeSheetService";
import { anchorOrigin } from "../../utils/constants";
import { useSnackbar } from "notistack";
import { formatToYYYYMonDD } from "../../utils/customC2CFormat";
import { useState, useEffect, useRef } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CalenderIcon from "../../assets/svg/menu/CalenderIcon";
import BackSvg from "../../assets/svg/ic_back.svg";
import CloseIcon from "@mui/icons-material/Close";
import {
  getTimesheetStatusMessage,
  TIMESHEET_STATUS
} from "../../utils/timesheetUtils";
import { TimesheetAttachment } from "./TimesheetAttachment";

import AllocatedIcon from "../../assets/svg/menu/AllocatedIcon";
import dayjs from "dayjs";
import ContentLoadingScreen from "../../components/ContentLoadingScreen";

const DEFAULT_MAX_WORKING_HOURS_PER_DAY = 8;
const DEFAULT_MAX_TIMESHEET_HOURS_PER_WEEK = 40;
const FLEX_SERVICE_MAX_HOURS = 56;
const DEFAULT_DISABLE_ZERO_ALLOCATED_DAYS = false;

const maxWorkingHoursPerDay =
  Number(process.env.REACT_APP_MAX_WORKING_HOURS_PER_DAY) ||
  DEFAULT_MAX_WORKING_HOURS_PER_DAY;

const disableZeroAllocatedDays =
  process.env.REACT_APP_DISABLE_ZERO_ALLOCATED_DAYS === "true" ||
  DEFAULT_DISABLE_ZERO_ALLOCATED_DAYS;

export default function EmpAddTimesheet({
  employeeId,
  handleClose,
  ongoingProjectArr,
  clinetNameArr,
  weekWiseTimesheetPage,
  alocatedDataHrs,
  isOngoingWeek,
  isRecall,
  setIsRecall,
  isProxyTimesheet,
  proxyEmpEmail,
  proxyEmpId
}) {
  const [isFlexService, setIsFlexService] = useState(false);
  const FLEX_SERVICE = "contract_type_3";
  const maxTimesheetHoursPerWeek = isFlexService
    ? FLEX_SERVICE_MAX_HOURS
    : Number(process.env.REACT_APP_MAX_TIMESHEET_HOURS_PER_WEEK) ||
      DEFAULT_MAX_TIMESHEET_HOURS_PER_WEEK;
  const { translate } = useLocales();
  const { userData } = useData();
  const { enqueueSnackbar } = useSnackbar();
  const [timesheetResponse, setTimesheetResponse] = useState(
    weekWiseTimesheetPage ? alocatedDataHrs : []
  );

  useEffect(() => {
    if (timesheetResponse?.files?.length > 0) {
      setUpLoadedFileUrls(timesheetResponse.files);
    } else if (
      timesheetResponse?.length > 0 &&
      timesheetResponse[0]?.files?.length > 0
    ) {
      setUpLoadedFileUrls(timesheetResponse[0].files);
    }
  }, [timesheetResponse]);
  const [checked, setChecked] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [timeoffComment, setTimeoffComment] = useState("");
  const [commentErr, setCommentErr] = useState("");
  const [weekNumber, setWeekNumber] = useState(0);
  const [timesheetYear, setTimesheetYear] = useState();
  const [isAutofilled, setAutofilled] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [timesheetRows, setTimesheetRows] = useState({ timesheetData: [] });
  const [upLoadedFileUrls, setUpLoadedFileUrls] = useState([]);
  const [deletedFileUrls, setDeletedFileUrls] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileUploaded, setFileUploaded] = useState({});
  const [fileTypeError, setFileTypeError] = useState("");

  const allowedFormats = (
    typeof process.env.REACT_APP_TS_FILE_UPLOAD_FORMATS === "string" &&
    process.env.REACT_APP_TS_FILE_UPLOAD_FORMATS.length > 0
      ? process.env.REACT_APP_TS_FILE_UPLOAD_FORMATS
      : "pdf"
  )
    .split(",")
    .map((f) => f.trim().toLowerCase());

  function isFileAllowed(file) {
    const ext = file.name.split(".").pop().toLowerCase();
    return allowedFormats.includes(ext);
  }

  useEffect(() => {
    const hasTimeOffHours = timesheetRows.timesheetData.some((row) => {
      const timeOffFilled = row.nonBillable?.timeOff?.filledTime || "";
      return /\d/.test(timeOffFilled) && timeOffFilled !== "00:00";
    });

    if (timeoffComment.length > 200) {
      setCommentErr("Maximum 200 characters allowed in comment");
    } else if (hasTimeOffHours && timeoffComment === "") {
      setCommentErr("Please enter comment if timeoff hours are entered");
    } else if (!hasTimeOffHours && timeoffComment !== "") {
      setCommentErr("Please remove comment if not adding timeoff hours.");
    } else {
      setCommentErr("");
    }
  }, [timesheetRows, timeoffComment]);

  const [submitErrMessage, setSubmitErrMessage] = useState("");

  const timesheetMessage = getTimesheetStatusMessage(timesheetResponse);
  const submitButtonText =
    timesheetMessage === TIMESHEET_STATUS.recall_msg ||
    timesheetMessage === TIMESHEET_STATUS.submitted_msg
      ? "Update Timesheet"
      : " Submit Timesheet";
  const [open, setOpen] = useState(false);
  const [isUploadClicked, setIsUploadClicked] = useState(false);
  const handleAllocationOpen = () => setOpen(true);
  const hasMounted = useRef(false);

  const handleAllocationClose = () => setOpen(false);
  const processedData = timesheetRows.timesheetData.map((entry) => ({
    date: entry.clients[0]?.date_str || "N/A",
    clients: entry.clients.reduce((acc, client) => {
      acc[client.name] =
        client.allocated !== "00:00" ? `${client.allocated}` : "-";
      return acc;
    }, {})
  }));

  const clientNames = [
    ...new Set(
      timesheetRows.timesheetData.flatMap((entry) =>
        entry.clients.map((c) => c.name)
      )
    )
  ];

  const [hoursSummary, setHoursSummary] = useState({
    totalHours: "",
    totalFilledHours: "",
    filledAllocatedHours: "",
    filledUnplannedHours: "",
    filledTimeoffHours: "",
    unplannedComments: "",
    timeoffComments: ""
  });
  const [errors, setErrors] = useState({});

  const convertToMinutes = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  };
  useEffect(() => {
    if (weekWiseTimesheetPage && alocatedDataHrs) {
      setStartDate(alocatedDataHrs[0].start_date);
      setEndDate(alocatedDataHrs[0].end_date);
      setWeekNumber(alocatedDataHrs[0].week_number);
    }
  }, [weekWiseTimesheetPage, alocatedDataHrs]);

  useEffect(() => {
    fetchTimesheetData();
  }, []);

  useEffect(() => {
    if (isRecall) {
      fetchRecallData();
    }
  }, [isRecall]);

  const fetchTimesheetData = async () => {
    setLoading(true);
    try {
      const userEmail = userData?.user_info?.email;
      const clientNames =
        ongoingProjectArr?.map((item) => item.client_name) || [];

      const payload =
        !weekWiseTimesheetPage && isOngoingWeek
          ? {
              employee_email: isProxyTimesheet ? proxyEmpEmail : userEmail,
              start_date: dayjs().startOf("week").format("YYYY-MM-DD"),
              end_date: dayjs().endOf("week").format("YYYY-MM-DD")
            }
          : alocatedDataHrs?.length > 0
          ? {
              employee_email: isProxyTimesheet ? proxyEmpEmail : userEmail,
              start_date: alocatedDataHrs[0].start_date,
              end_date: alocatedDataHrs[0].end_date
            }
          : null;

      if (payload && !isRecall) {
        const response = await TimeSheetAPI.TIMESHEET_ONGOING_ALLOCATEDHRS(
          axiosPrivate,
          payload
        );

        if (response && response.status === 200) {
          if (Array.isArray(response.data.timesheets)) {
            setIsFlexService(
              response.data.timesheets.some(
                (ts) => ts.contract_type === FLEX_SERVICE
              )
            );
            setTimesheetResponse(response.data);
            setStartDate(response.data.timesheets[0].week_start_date);
            setEndDate(response.data.timesheets[0].week_end_date);
            setWeekNumber(response.data.week_number);
            setTimeoffComment(response.data.timeoff_hours_comments);
            setTimesheetYear(response.data.year);
            if (response.data.files?.length > 0) {
              setUpLoadedFileUrls(response.data.files);
            }
          } else {
            setTimesheetResponse([]);
          }
        } else {
          console.error("Invalid response:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const convertToHours = (time) => {
    if (!time) return 0;
    const [hours, minutes] = time.split(":").map(Number);
    return hours + minutes / 60;
  };
  const exceededDates = timesheetRows.timesheetData
    .filter((day) => {
      const totalTime =
        day.clients.reduce(
          (sum, client) => sum + convertToHours(client.filledTime),
          0
        ) + convertToHours(day.nonBillable.timeOff.filledTime);
      return totalTime > maxWorkingHoursPerDay;
    })
    .map((day) => day.date);

  const isMaxHours =
    exceededDates.length > 0
      ? `Cannot exceed more than ${maxWorkingHoursPerDay} hours: ${exceededDates.join(
          ", "
        )}`
      : "";
  const allowMultiple = process.env.REACT_APP_MULTI_FILE_TS_UPLOAD === "true";
  const fetchRecallData = async () => {
    setLoading(true);
    if (isRecall) {
      setStartDate(alocatedDataHrs[0].start_date);
      setEndDate(alocatedDataHrs[0].end_date);
      const payload = {
        employee_email: isProxyTimesheet
          ? proxyEmpEmail
          : userData?.user_info?.email,
        start_date: alocatedDataHrs[0].start_date,
        end_date: alocatedDataHrs[0].end_date
      };

      try {
        const response = await TimeSheetAPI.RECALL_TIMESHEET(
          axiosPrivate,
          payload
        );
        if (response && response.status === 200) {
          setIsFlexService(
            response.data.timesheets.some(
              (ts) => ts.contract_type === FLEX_SERVICE
            )
          );
          setTimesheetResponse(response.data);
          setTimesheetYear(response.data.year);
          setTimeoffComment(response.data.timeoff_hours_comments);
          if (response.data.files?.length > 0) {
            setUpLoadedFileUrls(response.data.files);
          }
        } else {
          console.error("Invalid response:", response);
        }
        setIsRecall(false);
      } catch (error) {
        console.error("Error fetching recall timesheet:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const formatTimesheetRows = () => {
    if (
      !timesheetResponse?.timesheets ||
      !Array.isArray(timesheetResponse.timesheets)
    ) {
      setTimesheetRows({ timesheetData: [] });
      return;
    }

    // Collect week dates from ALL timesheets (not just the first) so the UI shows the full week
    const allDates = Array.from(
      new Set(
        (timesheetResponse.timesheets || []).flatMap((ts) =>
          (ts.daily_hour_json || []).map(({ date }) => date)
        )
      )
    ).sort();

    // Map date -> date_str once, prefer the first seen value
    const dateToDateStr = {};
    (timesheetResponse.timesheets || []).forEach((ts) => {
      (ts.daily_hour_json || []).forEach((d) => {
        if (!dateToDateStr[d.date]) {
          dateToDateStr[d.date] = d.date_str;
        }
      });
    });

    const weekDates = allDates;
    const unplannedData = timesheetResponse.unplanned_daily_hour_json || [];

    const timesheetData = weekDates.map((date, index) => {
      console.log("Processing date:", date, "at index:", index);

      // Build a client item for EACH timesheet to keep indices aligned across all days
      const clients = timesheetResponse.timesheets.map(
        ({
          client_name,
          daily_hour_json,
          contract_sow_name,
          timesheet_status,
          contract_start_date,
          contract_end_date
        }) => {
          const entry = daily_hour_json?.find((e) => e.date === date);

          return {
            name: client_name || "Unknown Client",
            contract_sow_name: contract_sow_name || "Unknown Sow Contract",
            allocated: entry?.allocated_hours || "00:00",
            date: date,
            date_str:
              entry?.date_str ||
              dateToDateStr[date] ||
              dayjs(date).format("ddd - DDMMM"),
            filledTime: timesheetResponse.timesheets.every(
              (ts) => ts.timesheet_status === TIMESHEET_STATUS.not_submitted
            )
              ? ""
              : entry?.timesheet_hours || "00:00",
            isChecked: false,
            timesheetStatus: timesheet_status,
            contract_start_date,
            contract_end_date
          };
        }
      );

      console.log(
        "Clients for date",
        date,
        "=>",
        JSON.stringify(clients, null, 2)
      );

      const unplannedEntry = unplannedData.find(
        (entry) => entry.date === date && entry.unplanned_hours
      );
      console.log(
        "Unplanned entry for",
        date,
        "=>",
        JSON.stringify(unplannedEntry, null, 2)
      );

      const timeoffEntry = unplannedData.find(
        (entry) => entry.date === date && entry.timeoff_hours
      );
      console.log(
        "Timeoff entry for",
        date,
        "=>",
        JSON.stringify(timeoffEntry, null, 2)
      );

      const result = {
        date,
        dateIndex: index,
        clients,
        nonBillable: {
          unplanned: {
            filledTime: unplannedEntry ? unplannedEntry.unplanned_hours : ""
          },
          timeOff: {
            filledTime: timeoffEntry ? timeoffEntry.timeoff_hours : ""
          }
        }
      };

      console.log(
        "Final result for date",
        date,
        "=>",
        JSON.stringify(result, null, 2)
      );

      return result;
    });

    console.log("Final timesheetData:", JSON.stringify(timesheetData, null, 2));

    console.log("Final timesheetData:", timesheetData);

    setTimesheetRows({
      timesheetData,
      timeoffComments: timesheetResponse.timeoff_hours_comments || "",
      unplannedComments: timesheetResponse.unplanned_hours_comments || "",
      unplannedTimesheetStatus:
        timesheetResponse.unplanned_timesheet_status || ""
    });
  };

  useEffect(() => {
    if (timesheetRows.timesheetData.length > 0) {
      hasMounted.current = true;
    }
  }, [timesheetRows]);

  useEffect(() => {
    formatTimesheetRows();
  }, [timesheetResponse]);

  const createSubmitPayload = (
    timesheetResponse,
    hoursSummary,
    employeeId,
    timesheetYear,
    weekNumber,
    apiData
  ) => {
    const clientMap = {};
    const unplannedDailyHours = [];

    const convertToHHMM = (num) => {
      if (typeof num === "string") {
        const [hours, minutes = "00"] = num
          .split(":")
          .map((val) => val.padStart(2, "0"));
        return `${hours}:${minutes}`;
      }
      if (isNaN(num)) return "00:00";
      const hours = Math.floor(num);
      const minutes = Math.round((num - hours) * 60);
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
    };

    const sumTime = (time1, time2) => {
      const [h1, m1] = (time1 || "00:00").split(":").map(Number);
      const [h2, m2] = (time2 || "00:00").split(":").map(Number);
      const totalMinutes = h1 * 60 + m1 + h2 * 60 + m2;
      return convertToHHMM(totalMinutes / 60);
    };

    let totalNonBillable = "00:00";
    let totalUnplanned = "00:00";

    timesheetResponse.timesheetData.forEach((day) => {
      day.clients.forEach((client) => {
        const contractName = client.contract_sow_name || "Unknown Contract";
        const clientKey = `${client.name}-${contractName}`;

        if (!clientMap[clientKey]) {
          clientMap[clientKey] = {
            client_name: client.name,
            contract_sow_name: contractName,
            daily_hour_json: [],
            timesheet_hours: "00:00"
          };
        }

        clientMap[clientKey].daily_hour_json.push({
          date: day.date,
          allocated_hours: convertToHHMM(client.allocated),
          timesheet_hours: convertToHHMM(client.filledTime || "00:00"),
          date_str: client.date_str
        });

        clientMap[clientKey].timesheet_hours = sumTime(
          clientMap[clientKey].timesheet_hours,
          client.filledTime || "00:00"
        );

        totalNonBillable = sumTime(
          totalNonBillable,
          client.filledTime || "00:00"
        );
      });

      if (
        day.nonBillable?.timeOff?.filledTime &&
        day.nonBillable.timeOff.filledTime !== "00:00"
      ) {
        const date_str = day.clients[0]?.date_str || "";

        unplannedDailyHours.push({
          date: day.date,
          timeoff_hours: convertToHHMM(day.nonBillable.timeOff.filledTime),
          date_str: date_str
        });

        totalUnplanned = sumTime(
          totalUnplanned,
          day.nonBillable.timeOff.filledTime || "00:00"
        );
      }
    });

    const timesheets = Object.values(clientMap).map((client) => {
      const matchingTimesheet = apiData.timesheets.find(
        (ts) => ts.contract_sow_name === client.contract_sow_name
      );

      return {
        timesheet: matchingTimesheet ? matchingTimesheet.timesheet : null,
        client_name: client.client_name,
        contract_sow_name: client.contract_sow_name,
        daily_hour_json: client.daily_hour_json,
        timesheet_hours: convertToHHMM(client.timesheet_hours || "00:00")
      };
    });

    const formData = new FormData();
    formData.append("employee_id", isProxyTimesheet ? proxyEmpId : employeeId);
    formData.append("year", timesheetYear);
    formData.append("week_number", weekNumber);
    // Append all selected files
    if (selectedFiles && selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        formData.append("file", file);
      });
    } else {
      formData.append("file", []);
    }
    formData.append(
      "non_billable_hours",
      convertToHHMM(hoursSummary.filledTimeoffHours || "00:00")
    );
    formData.append(
      "unplanned_hours",
      convertToHHMM(hoursSummary.filledUnplannedHours || "00:00")
    );
    formData.append(
      "total_hours",
      convertToHHMM(hoursSummary.totalHours || "00:00")
    );
    formData.append("non_billable_hours_comments", timeoffComment || "");
    formData.append(
      "unplanned_hours_comments",
      hoursSummary.unplannedComments || ""
    );
    formData.append(
      "unplanned_daily_hour_json",
      JSON.stringify(unplannedDailyHours)
    );
    formData.append("timesheets", JSON.stringify(timesheets));
    formData.append("submitted_by", userData?.user_info?.email || "");
    if (isProxyTimesheet) {
      formData.append("proxy_comment", proxyComment || "");
    }
    if (fileUploaded && fileUploaded.name) {
      formData.append("file", fileUploaded);
    }

    return formData;
  };

  const onSubmitTimesheetClick = async () => {
    setLoading(true);

    try {
      const payload = createSubmitPayload(
        timesheetRows,
        hoursSummary,
        employeeId,
        timesheetYear,
        weekNumber,
        timesheetResponse
      );

      const response = await TimeSheetAPI.ADD_TIMESHEET(axiosPrivate, payload);
      if (isValidResponse(response)) {
        onSucces(response?.data);
        handleClose();
      }
    } catch (error) {
      console.log("Error while adding timesheet:", error);

      enqueueSnackbar(
        translate("Failed to submit timesheet. Please try again."),
        {
          variant: "error",
          anchorOrigin
        }
      );
    } finally {
      setLoading(false);
    }
  };

  const onSucces = (message) => {
    enqueueSnackbar(translate("Timesheet Submitted Successfully"), {
      anchorOrigin
    });
  };

  const minTimesheetHours = isFlexService
    ? 0
    : timesheetRows.timesheetData.reduce(
        (acc, day) =>
          acc +
          day.clients.reduce(
            (sum, client) =>
              sum +
              (client.allocated !== "00:00"
                ? Number(client.allocated.split(":")[0]) * 60 +
                  Number(client.allocated.split(":")[1])
                : 0),
            0
          ),
        0
      );
  useEffect(() => {
    if (!isFlexService && hoursSummary.totalHours === "00:00") {
      setSubmitErrMessage("");
      setIsSubmitDisabled(true);
      return;
    }

    const totalHours = convertToMinutes(hoursSummary.totalHours);
    const requiredMinutes = maxTimesheetHoursPerWeek * 60;

    const isWithinAllocatedRange =
      totalHours >= minTimesheetHours && totalHours <= requiredMinutes;

    const formatMinutesToHHMM = (minutes) => {
      const hrs = Math.floor(minutes / 60)
        .toString()
        .padStart(2, "0");
      const mins = (minutes % 60).toString().padStart(2, "0");
      return `${hrs}:${mins}`;
    };

    const formattedMinHours = formatMinutesToHHMM(minTimesheetHours);
    const maxHours = formatMinutesToHHMM(maxTimesheetHoursPerWeek * 60);

    const errorMessage = !isWithinAllocatedRange
      ? `Timesheet hours must be greater than or equal to allocated hours (${formattedMinHours}) and cannot exceed ${maxHours} hours.`
      : "";

    setSubmitErrMessage(errorMessage);
    setIsSubmitDisabled(!isWithinAllocatedRange);
  }, [hoursSummary, minTimesheetHours]);
  useEffect(() => {
    if (timesheetRows && timesheetRows.timesheetData) {
      const newErrors = {};

      timesheetRows.timesheetData.forEach((day, dateIndex) => {
        day.clients.forEach((client, clientIndex) => {
          const allocatedHours = client.allocated;
          const filledTime = client.filledTime;

          if (allocatedHours && filledTime) {
            const [allocatedHoursHours, allocatedHoursMinutes] = allocatedHours
              .split(":")
              .map(Number);
            const [filledTimeHours, filledTimeMinutes] = filledTime
              .split(":")
              .map(Number);

            const totalAllocatedMinutes =
              allocatedHoursHours * 60 + allocatedHoursMinutes;
            const totalFilledMinutes = filledTimeHours * 60 + filledTimeMinutes;

            if (totalFilledMinutes > totalAllocatedMinutes) {
              const errorMessage = `${day.date} (${client.contract_sow_name}) :Overtime requires manager approval. Check to confirm`;
              newErrors[`${dateIndex}-${clientIndex}`] = [errorMessage];
            }
          }
        });
      });

      setErrors(newErrors);
    }
  }, [hasMounted.current]);

  useEffect(() => {
    let totalFilled = 0;
    let totalAllocatedFilled = 0;
    let totalUnplanned = 0;
    let totalTimeOff = 0;

    const timeToMinutes = (time) => {
      if (!time) return 0;
      if (typeof time !== "string") {
        return typeof time === "number" ? time : 0;
      }
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    };

    if (timesheetRows && timesheetRows.timesheetData) {
      timesheetRows.timesheetData.forEach((day) => {
        if (day.clients) {
          day.clients.forEach((client) => {
            const filled = timeToMinutes(client.filledTime);
            totalFilled += filled;
            totalAllocatedFilled += filled;
          });
        }
        if (day.nonBillable && day.nonBillable.unplanned) {
          totalUnplanned += timeToMinutes(day.nonBillable.unplanned.filledTime);
        }
        if (day.nonBillable && day.nonBillable.timeOff) {
          totalTimeOff += timeToMinutes(day.nonBillable.timeOff.filledTime);
        }
      });
    }

    const totalFilledHours = totalFilled + totalUnplanned + totalTimeOff;

    const convertToHHMM = (minutes) => {
      const hrs = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
    };

    const computedSummary = {
      totalHours: convertToHHMM(totalFilledHours),
      totalFilledHours: convertToHHMM(totalAllocatedFilled),
      filledUnplannedHours: convertToHHMM(totalUnplanned),
      filledTimeoffHours: convertToHHMM(totalTimeOff),
      unplannedComments: timesheetRows?.unplannedComments || "",
      timeoffComments: timesheetRows?.timeoffComments || ""
    };

    setHoursSummary(computedSummary);
  }, [timesheetRows]);

  const validateInput = (
    value,
    allocatedHours,
    isNonBillable = false,
    clientIndex,
    dateIndex
  ) => {
    const errorMessages = [];

    if (value.trim() === "") {
      return errorMessages;
    }

    const regex = /^\d{1,2}:\d{1,2}$/;
    if (!regex.test(value)) {
      errorMessages.push("Enter hh:mm format");
    } else {
      let [hours, minutes] = value.split(":").map(Number);
      let enteredTotalMins = hours * 60 + minutes;

      if (minutes > 59) {
        errorMessages.push("Max 59 minutes");
      }

      let allocatedHourValue = 0,
        allocatedMinuteValue = 0,
        allocatedTotalMins = 0;
      if (allocatedHours && typeof allocatedHours === "string") {
        [allocatedHourValue, allocatedMinuteValue] = allocatedHours
          .split(":")
          .map(Number);
        allocatedTotalMins = allocatedHourValue * 60 + allocatedMinuteValue;
      }

      if (isNonBillable) {
        if (hours > maxWorkingHoursPerDay) {
          errorMessages.push(`Enter max ${maxWorkingHoursPerDay} hours`);
        }
      } else {
        if (
          allocatedTotalMins !== undefined &&
          enteredTotalMins > allocatedTotalMins
        ) {
          if (
            !timesheetRows.timesheetData[dateIndex]?.clients?.[clientIndex]
              ?.isChecked
          ) {
            errorMessages.push(
              "Overtime requires manager approval. Check to confirm"
            );
          }
        }
      }
    }

    return errorMessages;
  };
  const [proxyComment, setProxyComment] = useState("");

  useEffect(() => {
    setProxyComment(timesheetResponse.proxy_comment);
  }, [timesheetResponse]);
  const hasOvertimeError = Object.values(errors).some((messages) =>
    messages.some((message) =>
      message.includes("Overtime requires manager approval. Check to confirm")
    )
  );

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const validateComment = (value) => {
    if (value.length > 200) {
      return ["Comment cannot exceed 200 characters"];
    }

    const regex = /^[a-zA-Z0-9\s.,!?@#$%^&*()_+\-[\]{};':"\\|<>?/`~]*$/;

    if (!regex.test(value)) {
      return ["Only letters, numbers, spaces, and common punctuation allowed"];
    }

    return [];
  };

  const autofillAllocatedHours = () => {
    // First clear all existing data
    setTimesheetRows((prevState) => {
      const clearedData = prevState.timesheetData.map((day) => {
        return {
          ...day,
          clients: day.clients.map((client) => {
            return {
              ...client,
              filledTime: "", // Clear existing filled time
              isChecked: false
            };
          }),
          nonBillable: {
            ...day.nonBillable,
            timeOff: {
              filledTime: "" // Clear timeoff hours as well
            }
          }
        };
      });

      return { timesheetData: clearedData };
    });

    // Then autofill with allocated hours
    setTimesheetRows((prevState) => {
      const updatedData = prevState.timesheetData.map((day) => {
        return {
          ...day,
          clients: day.clients.map((client) => {
            return {
              ...client,
              filledTime: client.allocated,
              isChecked: false
            };
          })
        };
      });

      return { timesheetData: updatedData };
    });

    // Clear any existing error messages
    setErrors({});
    setTimeoffComment(""); // Clear timeoff comment
    setCommentErr(""); // Clear comment error

    enqueueSnackbar(
      translate(
        "Timesheet hours auto-filled based on allocations. You can now submit."
      ),
      {
        variant: "success",
        anchorOrigin
      }
    );
    setAutofilled(true);
  };

  useEffect(() => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      timesheetRows.timesheetData.forEach((day, dateIndex) => {
        day.clients.forEach((client, clientIndex) => {
          if (client.filledTime === "00:00") {
            delete updatedErrors[`${dateIndex}-${clientIndex}`];
          }
        });
      });
      return updatedErrors;
    });
  }, [timesheetRows]);

  const updateTimesheetRows = (
    dateIndex,
    clientIndex,
    value,
    isComment = false
  ) => {
    if (isComment) {
      const validationErrors = validateComment(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`comment-${clientIndex}`]: validationErrors.length
          ? [
              clientIndex === -1
                ? "Unplanned Comments: " + validationErrors[0]
                : "Timeoff Comments: " + validationErrors[0]
            ]
          : undefined
      }));

      if (clientIndex === -1 && dateIndex === null) {
        setTimesheetRows((prevState) => ({
          ...prevState,
          unplannedComments: value
        }));
      } else if (clientIndex === -2 && dateIndex === null) {
        setTimesheetRows((prevState) => ({
          ...prevState,
          timeoffComments: value
        }));
      }
      return;
    }

    setTimesheetRows((prevState) => {
      const updatedData = prevState.timesheetData.map((day, idx) => {
        if (idx === dateIndex) {
          return {
            ...day,
            clients: day.clients.map((client, cIdx) =>
              cIdx === clientIndex
                ? { ...client, filledTime: value, isChecked: false }
                : client
            ),
            nonBillable:
              clientIndex < 0
                ? {
                    ...day.nonBillable,
                    [clientIndex === -1 ? "unplanned" : "timeOff"]: {
                      filledTime: value
                    }
                  }
                : day.nonBillable
          };
        }
        return day;
      });

      const date = prevState.timesheetData[dateIndex]?.date;
      const clientName =
        clientIndex >= 0
          ? prevState.timesheetData[dateIndex]?.clients?.[clientIndex]
              ?.contract_sow_name
          : clientIndex === -1
          ? "Unplanned"
          : "Time Off";

      const allocatedHours =
        clientIndex >= 0
          ? prevState.timesheetData[dateIndex]?.clients?.[clientIndex]
              ?.allocated || 0
          : 0;
      const isNonBillable = clientIndex < 0;
      const validationErrors = validateInput(
        value,
        allocatedHours,
        isNonBillable
      );

      setErrors((prevErrors) => {
        const formattedErrors = validationErrors.map(
          (error) => `${date} (${clientName}) :${error}`
        );
        return {
          ...prevErrors,
          [`${dateIndex}-${clientIndex}`]: formattedErrors
        };
      });

      return { timesheetData: updatedData };
    });
  };

  const handleDownloadFile = async (uuid, blobName) => {
    try {
      // Use UploadFileAPI.DOWNLOAD to get the endpoint
      const url = UploadFileAPI.DOWNLOAD(uuid);
      // Use axiosPrivate to fetch the file as a blob
      const response = await axiosPrivate.get(url, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.microsoft_code}`
        },
        responseType: "blob"
      });
      // Create a blob and trigger download
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = blobName || "downloaded_file";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
      enqueueSnackbar("Download successful", {
        variant: "success",
        anchorOrigin
      });
    } catch (error) {
      console.error("Download failed", error);
      enqueueSnackbar("Download failed", { variant: "error", anchorOrigin });
    }
  };

  const handleDeleteFile = async (uuid) => {
    try {
      await UploadFileAPI.DELETE(axiosPrivate, uuid);
      setUpLoadedFileUrls((prev) => prev.filter((file) => file.uuid !== uuid));
      enqueueSnackbar("File deleted successfully", {
        variant: "success",
        anchorOrigin
      });
    } catch (error) {
      console.error("Delete failed", error);
      enqueueSnackbar("File delete failed", { variant: "error", anchorOrigin });
    }
  };

  useEffect(() => {
    const hasOvertimeErrors = Object.values(errors).some((messages = []) =>
      messages.some((message) =>
        message.includes("Overtime requires manager approval. Check to confirm")
      )
    );

    if (!hasOvertimeErrors) {
      setChecked(false);
    }
  }, [errors]);

  const errorMessageStyle = {
    color: "error.main",
    fontSize: "13px",
    fontWeight: 500
  };

  return (
    <Box>
      {isLoading ? (
        <ContentLoadingScreen />
      ) : (
        <Box padding={"2%"}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <img
                src={BackSvg}
                alt="BackIcon"
                style={{ cursor: "pointer" }}
                onClick={handleClose}
              />

              <Typography noWrap sx={{ fontWeight: 700, fontSize: "20px" }}>
                Submit Timesheet
              </Typography>
            </Stack>
          </Stack>
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ marginBottom: "20px", marginTop: "35px" }}
          >
            <Typography variant="subtitle1">Start Date - End Date</Typography>
            <Box
              display="flex"
              alignItems="center"
              sx={{
                border: "2px solid #8E97A7",
                padding: "8px",
                borderRadius: "4px",
                marginLeft: "5px"
              }}
            >
              <CalenderIcon />
              <Typography
                variant="body1"
                sx={{ fontSize: "14px", fontWeight: 400, ml: 0.5 }}
              >
                {formatToYYYYMonDD(startDate)} - {formatToYYYYMonDD(endDate)}
              </Typography>
            </Box>
            {timesheetMessage && (
              <Box
                sx={{
                  marginLeft: "auto",
                  padding: "5px 20px",
                  backgroundColor: "#edf2f7",
                  borderRadius: "4px",
                  border: "1px solid #cbd5e0"
                }}
              >
                <Typography color={"error"}>{timesheetMessage}</Typography>
              </Box>
            )}
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Box display="flex" alignItems="center" sx={boxStyle}>
              <Typography variant="body1" sx={labelStyle}>
                Total Hours -{"\u00A0"}
              </Typography>
              <Typography variant="body1" sx={valueStyle}>
                {hoursSummary.totalHours}
              </Typography>
              <Typography variant="body1" sx={dividerStyle}>
                |
              </Typography>

              <Typography variant="body1" sx={labelStyle}>
                Timesheet Hours -{"\u00A0"}
              </Typography>
              <Typography variant="body1" sx={valueStyle}>
                {hoursSummary.totalFilledHours}
              </Typography>
              <Typography variant="body1" sx={dividerStyle}>
                |
              </Typography>
              {/* <Typography variant="body1" sx={labelStyle}>
                Unallocated Hours -{"\u00A0"}
              </Typography>
              <Typography variant="body1" sx={valueStyle}>
                {hoursSummary.filledUnplannedHours}
              </Typography>
              <Typography variant="body1" sx={dividerStyle}>
                |
              </Typography> */}

              <Typography variant="body1" sx={labelStyle}>
                Timeoff Hours -{"\u00A0"}
              </Typography>
              <Typography variant="body1" sx={valueStyle}>
                {hoursSummary.filledTimeoffHours}
              </Typography>
            </Box>

            {timesheetMessage === TIMESHEET_STATUS.not_submitted_msg && (
              <Tooltip
                title="Auto-Populate Timesheet Hours (TH) from Allocated Hours (AH)"
                arrow
              >
                <Button
                  variant="outlined"
                  style={{
                    marginRight: "8px"
                  }}
                  onClick={autofillAllocatedHours}
                  disabled={isAutofilled}
                >
                  Auto-Fill TH
                </Button>
              </Tooltip>
            )}
          </Box>

          {(timesheetResponse?.timesheets || [])
            .filter(
              (timesheet) =>
                timesheet.timesheet_status === TIMESHEET_STATUS.recall
            )
            .map((timesheet, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                sx={recallBoxStyle}
              >
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, fontSize: "13px", marginRight: "8px" }}
                >
                  Project Manager's Comment ({timesheet.client_name}):
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 400, fontSize: "13px" }}
                >
                  {timesheet.manager_comments}
                </Typography>
              </Box>
            ))}
          {timesheetResponse.unplanned_timesheet_status ===
            TIMESHEET_STATUS.recall && (
            <Box display="flex" alignItems="center" sx={recallBoxStyle}>
              <Typography
                variant="body1"
                sx={{ fontWeight: 600, fontSize: "13px", marginRight: "8px" }}
              >
                HR Manager's Comment:
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: 400, fontSize: "13px" }}
              >
                {timesheetResponse.hr_manager_comments}
              </Typography>
            </Box>
          )}
          <TableContainer
            component={Paper}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Table style={{ fontSize: "12px" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    align="left"
                    style={{ ...tableCellStyle, paddingLeft: "10px" }}
                  >
                    Project Name
                  </TableCell>

                  {timesheetRows?.timesheetData?.map(
                    ({ clients }) =>
                      clients.length > 0 && (
                        <TableCell
                          align="center"
                          key={clients[0].date_str}
                          style={{ ...tableCellStyle, whiteSpace: "nowrap" }}
                        >
                          <Box>{clients[0].date_str}</Box>
                        </TableCell>
                      )
                  )}

                  <TableCell align="center" style={tableCellStyle}>
                    <Typography fontWeight={600} fontSize="13px">
                      Comments
                    </Typography>
                    <Typography
                      fontWeight={400}
                      fontSize="10px"
                      display="block"
                    >
                      <span>(200 char limit)</span>
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {timesheetRows?.timesheetData?.[0]?.clients?.map(
                  (_, clientIndex) => (
                    <TimesheetRow
                      isFlexService={isFlexService}
                      key={clientIndex}
                      label={
                        timesheetRows?.timesheetData?.[0]?.clients?.[
                          clientIndex
                        ]?.contract_sow_name || ""
                      }
                      data={timesheetRows.timesheetData.map(
                        (day) => day.clients[clientIndex]
                      )}
                      clientIndex={clientIndex}
                      updateTimesheetRows={updateTimesheetRows}
                      errors={errors}
                      timesheetResponse={timesheetResponse}
                    />
                  )
                )}
                {/* <TimesheetRow
                  label="Unallocated Hours"
                  data={timesheetRows.timesheetData.map(
                    (day) => day.nonBillable.unplanned
                  )}
                  timesheetRows={timesheetRows}
                  clientIndex={-1}
                  updateTimesheetRows={updateTimesheetRows}
                  errors={errors}
                  setTimesheetRows={setTimesheetRows}
                  tooltipTitle="Did you have any unplanned, unallocated or non-working time? Enter it here"
                /> */}
                <TimesheetRow
                  label="Time Off Hours"
                  data={timesheetRows.timesheetData.map(
                    (day) => day.nonBillable.timeOff
                  )}
                  isFlexService={isFlexService}
                  timesheetRows={timesheetRows}
                  errors={errors}
                  clientIndex={-2}
                  updateTimesheetRows={updateTimesheetRows}
                  setTimesheetRows={setTimesheetRows}
                  tooltipTitle="Enter time taken for Sick Leave, OOO, Casual Leave, or Holidays."
                  setTimeoffComment={setTimeoffComment}
                  timeoffComment={timeoffComment}
                  commentErr={commentErr}
                />
              </TableBody>
            </Table>
          </TableContainer>
          {Object.keys(errors).length > 0 && (
            <Typography sx={{ ...errorMessageStyle, marginTop: "10px" }}>
              {(() => {
                // Handle overtime errors first
                const overtimeErrors = Object.entries(errors).filter(
                  ([key, err = []]) =>
                    err.some((message) =>
                      message.includes(
                        "Overtime requires manager approval. Check to confirm"
                      )
                    )
                );

                if (overtimeErrors.length > 0) {
                  const dates = overtimeErrors.map(([key, err]) => {
                    const [dateIndex, clientIndex] = key.split("-").map(Number);
                    const date =
                      timesheetRows?.timesheetData?.[dateIndex]?.date;
                    const clientName =
                      timesheetRows?.timesheetData?.[dateIndex]?.clients?.[
                        clientIndex
                      ]?.contract_sow_name || "";
                    return `${date} (${clientName})`;
                  });

                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={handleChange}
                      />
                      <span>
                        Overtime needs manager approval for dates:{" "}
                        {dates.join(", ")}
                      </span>
                    </div>
                  );
                }

                // Group other errors by error message
                const groupedErrors = Object.entries(errors).reduce(
                  (acc, [key, messages = []]) => {
                    // Skip overtime errors as they're handled above
                    if (
                      messages.some((msg) =>
                        msg.includes("Overtime requires manager approval")
                      )
                    ) {
                      return acc;
                    }

                    messages.forEach((message) => {
                      const [dateAndProject, errorType] = message.split(":");
                      if (errorType) {
                        const trimmedError = errorType.trim();
                        if (!acc[trimmedError]) {
                          acc[trimmedError] = [];
                        }
                        acc[trimmedError].push(dateAndProject);
                      }
                    });
                    return acc;
                  },
                  {}
                );

                return Object.entries(groupedErrors).map(
                  ([errorType, dates], index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        marginBottom: "5px"
                      }}
                    >
                      {`${errorType}: ${dates.join(", ")}`}
                    </div>
                  )
                );
              })()}
            </Typography>
          )}

          {isMaxHours && (
            <Typography sx={{ ...errorMessageStyle, marginTop: "10px" }}>
              {isMaxHours}
            </Typography>
          )}
          {commentErr && (
            <Typography sx={{ ...errorMessageStyle, marginTop: "10px" }}>
              {commentErr}
            </Typography>
          )}

          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              marginTop: "20px"
            }}
          >
            {isProxyTimesheet && (
              <Box
                sx={{
                  fontSize: 11,
                  backgroundColor: "#fffde7",
                  border: "1px solid #fdd835",

                  p: 2,
                  m: 2,
                  mt: 2,
                  color: "#333"
                }}
              >
                <Typography sx={{ mb: 1.5, fontWeight: 500 }}>
                  If you're filling out the proxy timesheet on behalf of an
                  employee, please add a comment:
                </Typography>

                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  maxRows={4}
                  variant="outlined"
                  placeholder="Enter your comment"
                  value={proxyComment}
                  onChange={(e) => setProxyComment(e.target.value)}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 1,
                    "& .MuiOutlinedInput-root": {
                      fontSize: 14
                    }
                  }}
                />
              </Box>
            )}
            {timesheetResponse.proxy_comment && !isProxyTimesheet && (
              <Box
                sx={{
                  fontSize: 11,
                  backgroundColor: "#fffde7",
                  border: "1px solid #fdd835",
                  p: 1,
                  mb: 2,
                  color: "#333"
                }}
              >
                <Typography sx={{ fontWeight: 500 }}>
                  {`This timesheet was submitted by the ${timesheetResponse.submitted_by_name} as Timesheet Admin with the comment: "${timesheetResponse.proxy_comment}"`}
                </Typography>
              </Box>
            )}
            <Box style={{ display: "flex", alignItems: "center" }}>
              <>
                {allowMultiple ? (
                  <input
                    type="file"
                    id="attachment-input"
                    multiple
                    accept={allowedFormats.map((f) => "." + f).join(",")}
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      const validFiles = files.filter(isFileAllowed);
                      const invalidFiles = files.filter(
                        (f) => !isFileAllowed(f)
                      );
                      if (invalidFiles.length > 0) {
                        setFileTypeError(
                          `Only the following file format(s) are allowed: ${allowedFormats.join(
                            ", "
                          )}`
                        );
                      } else {
                        setFileTypeError("");
                      }
                      setSelectedFiles((prev) => [
                        ...prev,
                        ...validFiles.filter(
                          (f) =>
                            !prev.some(
                              (p) => p.name === f.name && p.size === f.size
                            )
                        )
                      ]);
                      // reset input so same file can be chosen again if needed
                      e.target.value = "";
                    }}
                  />
                ) : (
                  <input
                    type="file"
                    id="attachment-input"
                    accept={allowedFormats.map((f) => "." + f).join(",")}
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      const validFiles = files.filter(isFileAllowed);
                      const invalidFiles = files.filter(
                        (f) => !isFileAllowed(f)
                      );
                      if (invalidFiles.length > 0) {
                        setFileTypeError(
                          `Only the following file format(s) are allowed: ${allowedFormats.join(
                            ", "
                          )}`
                        );
                      } else {
                        setFileTypeError("");
                      }
                      setSelectedFiles((prev) => [
                        ...prev,
                        ...validFiles.filter(
                          (f) =>
                            !prev.some(
                              (p) => p.name === f.name && p.size === f.size
                            )
                        )
                      ]);
                      // reset input so same file can be chosen again if needed
                      e.target.value = "";
                    }}
                  />
                )}
                {fileTypeError && (
                  <Typography sx={{ color: "red", fontSize: "13px", mt: 1 }}>
                    {fileTypeError}
                  </Typography>
                )}
              </>
              <Button
                variant="outlined"
                style={{
                  borderColor: "#8E97A7",
                  color: "#8E97A7",
                  marginRight: "8px"
                }}
                onClick={() =>
                  document.getElementById("attachment-input").click()
                }
              >
                Add Attachment
              </Button>

              <Button
                variant="outlined"
                style={{ borderColor: "#8E97A7", color: "#8E97A7" }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{ marginLeft: "8px" }}
                disabled={
                  isSubmitDisabled ||
                  timesheetMessage === TIMESHEET_STATUS.approved_msg ||
                  (hasOvertimeError && !checked) ||
                  commentErr !== "" ||
                  (isProxyTimesheet && !proxyComment)
                }
                onClick={onSubmitTimesheetClick}
              >
                {submitButtonText}
              </Button>
            </Box>{" "}
            {/* File preview UI for selected files */}
            {selectedFiles.length > 0 && (
              <Box
                sx={{
                  mt: 3,
                  mb: 3,
                  mr: 4,
                  alignSelf: "flex-start",
                  border: "1.5px solid #E0E3E7",
                  background: "#F8FAFB",
                  borderRadius: 2,
                  px: 3,
                  py: 2,
                  minWidth: 260,

                  boxShadow: "0 1px 4px 0 rgba(21, 27, 38, 0.04)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start"
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  Selected Attachments:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: 1,
                    alignItems: "flex-start"
                  }}
                >
                  {selectedFiles.map((file, idx) => (
                    <Box
                      key={file.name + file.size}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #D1D5DB",
                        borderRadius: 2,
                        px: 2,
                        py: 1,
                        background: "#FAFAFA",
                        minWidth: 180,
                        mb: 1,
                        mr: 1
                      }}
                    >
                      <InsertDriveFileIcon sx={{ mr: 1, color: "#1976d2" }} />
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, flexGrow: 1 }}
                      >
                        {file.name}
                      </Typography>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setSelectedFiles((prev) =>
                            prev.filter((_, i) => i !== idx)
                          );
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
            {upLoadedFileUrls.length > 0 && (
              <Box sx={{ mt: 2, width: "100%" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mb: 1 }}
                >
                  Submitted Files:
                </Typography>
                <Stack direction="row" spacing={2} flexWrap="wrap">
                  {upLoadedFileUrls.map((file) => (
                    <Box
                      key={file.uuid}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #D1D5DB",
                        borderRadius: 2,
                        px: 2,
                        py: 1,
                        background: "#FAFAFA",
                        minWidth: 180,
                        mb: 1,
                        mr: 1
                      }}
                    >
                      <InsertDriveFileIcon sx={{ mr: 1, color: "#1976d2" }} />
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, flexGrow: 1 }}
                      >
                        {file.blob_name}
                      </Typography>
                      <Tooltip title="Download">
                        <IconButton
                          onClick={() =>
                            handleDownloadFile(file.uuid, file.blob_name)
                          }
                          size="small"
                        >
                          <DownloadIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          onClick={() => handleDeleteFile(file.uuid)}
                          size="small"
                          color="error"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  ))}
                </Stack>
              </Box>
            )}
            {submitErrMessage && (
              <Typography
                color="error"
                fontSize="13px"
                fontWeight={500}
                sx={{ marginTop: "8px", textAlign: "right" }}
              >
                {submitErrMessage}
              </Typography>
            )}
          </Box>
        </Box>
      )}

      <Dialog
        open={open}
        onClose={handleAllocationClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          style={{
            marginBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          Allocated Hours Per Project
          <IconButton onClick={handleAllocationClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  {clientNames.map((client) => (
                    <TableCell key={client}>{client}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {processedData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.date}</TableCell>
                    {clientNames.map((client) => (
                      <TableCell key={client}>
                        {row.clients[client] || "-"}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

const TimesheetRow = ({
  label,
  data,
  clientIndex,
  updateTimesheetRows,
  tooltipTitle,
  errors,
  timesheetRows,
  timesheetResponse,
  setTimeoffComment,
  timeoffComment,
  commentErr,
  isFlexService
}) => {
  const formattedData = timesheetResponse?.timesheets
    .filter((timesheet) => timesheet.contract_sow_name === label)
    .map((timesheet) => {
      return timesheet.daily_hour_json.map((dailyData) => ({
        date: dailyData.date_str,
        allocated_hours: dailyData.allocated_hours
      }));
    })
    .flat();

  // Get project start and end dates
  const projectData = timesheetResponse?.timesheets?.find(
    (timesheet) => timesheet.contract_sow_name === label
  );
  const projectStartDate = projectData?.contract_start_date;
  const projectEndDate = projectData?.contract_end_date;

  const FLEX_SERVICE = "contract_type_3";
  const isFlexRow = projectData?.contract_type === FLEX_SERVICE;

  const [shouldTimeoffCommentDisable, setShouldTimeoffCommentDisable] =
    useState(false);

  useEffect(() => {
    const hasTimeOffHours = timesheetRows?.timesheetData?.some((day) => {
      const timeOffFilled = day.nonBillable?.timeOff?.filledTime || "";
      return timeOffFilled !== "" && timeOffFilled !== "00:00";
    });

    // Only disable if there are no timeoff hours AND no existing comment
    setShouldTimeoffCommentDisable(!hasTimeOffHours && !timeoffComment);
  }, [timesheetRows, timeoffComment]);

  const formatTimeInput = (inputValue) => {
    let formattedValue = inputValue.replace(/[^0-9:]/g, "");

    if (formattedValue === "") {
      return "";
    }

    if (formattedValue.length === 1 && !formattedValue.includes(":")) {
      formattedValue = `0${formattedValue}:00`;
    }

    if (formattedValue.length === 2 && !formattedValue.includes(":")) {
      formattedValue = `${formattedValue}:`;
    }

    if (formattedValue.includes(":")) {
      const [hours, minutes] = formattedValue.split(":");

      if (minutes?.length > 2) {
        formattedValue = `${hours}:${minutes.slice(0, 2)}`;
      }
    }

    return formattedValue;
  };

  // Function to check if a date is within project start and end dates
  const isDateWithinProjectDates = (day) => {
    if (!day || !day.date) {
      return true;
    }

    if (!day.contract_start_date || !day.contract_end_date) {
      return true;
    }

    const currentDate = new Date(day.date);
    const startDate = new Date(day.contract_start_date);
    const endDate = new Date(day.contract_end_date);

    // Check if dates are valid
    if (
      isNaN(currentDate.getTime()) ||
      isNaN(startDate.getTime()) ||
      isNaN(endDate.getTime())
    ) {
      return true;
    }

    const isWithin = currentDate >= startDate && currentDate <= endDate;

    return isWithin;
  };

  // Function to check if input should be disabled based on allocated hours
  const isDisabledByAllocatedHours = (day) => {
    // If the setting is enabled and allocated hours are "00:00", disable the input
    if (disableZeroAllocatedDays && day.allocated === "00:00") {
      return true;
    }
    return false;
  };

  // Function to get tooltip message based on date validation
  const getDateValidationTooltip = (day) => {
    if (!day || !day.date) {
      return "";
    }

    if (!day.contract_start_date || !day.contract_end_date) {
      return "";
    }

    // Use dayjs to handle dates in local timezone
    const currentDate = dayjs(day.date).startOf("day");
    const startDate = dayjs(day.contract_start_date).startOf("day");
    const endDate = dayjs(day.contract_end_date).startOf("day");

    // Check if dates are valid
    if (!currentDate.isValid() || !startDate.isValid() || !endDate.isValid()) {
      return "";
    }

    // Format date to "Day - DDMon" format using dayjs
    const formatDate = (date) => {
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      const dayName = days[date.day()];
      const day = String(date.date()).padStart(2, "0");
      const month = months[date.month()];
      return `${dayName} - ${day}${month}`;
    };

    if (currentDate.isBefore(startDate)) {
      return `This day is disabled because the project starts on ${formatDate(
        startDate
      )}`;
    }
    if (currentDate.isAfter(endDate)) {
      return `This day is disabled because the project ended on ${formatDate(
        endDate
      )}`;
    }
    return "";
  };

  // Function to get tooltip message for zero allocated hours
  const getZeroAllocatedTooltip = (day) => {
    if (disableZeroAllocatedDays && day.allocated === "00:00") {
      return "This day is disabled because no hours are allocated";
    }
    return "";
  };

  // Function to get the appropriate tooltip based on all conditions
  const getTooltipMessage = (day, idx, clientIndex) => {
    // First check for weekend conditions
    if (
      clientIndex === -2 &&
      timesheetRows?.timesheetData[idx]?.clients[0]?.date_str &&
      (timesheetRows.timesheetData[idx].clients[0].date_str.includes("Sun") ||
        timesheetRows.timesheetData[idx].clients[0].date_str.includes("Sat"))
    ) {
      return isFlexService ? "" : "No timeoff hours allowed for weekend";
    }

    if (
      day.date_str &&
      (day.date_str.includes("Sun") || day.date_str.includes("Sat"))
    ) {
      if (!isFlexRow && day.allocated === "00:00") {
        return "No allocated hours for weekend";
      }
      return "";
    }

    // Check for weekend days (index 0 or 6)
    if (idx === 0 || idx === 6) {
      return "";
    }

    // Check for approved timesheet
    if (day.timesheetStatus === TIMESHEET_STATUS.approved) {
      return "Project manager has approved your timesheet";
    }

    // Check for approved unplanned timesheet
    if (
      timesheetRows?.unplannedTimesheetStatus === TIMESHEET_STATUS.approved &&
      (clientIndex === -1 || clientIndex === -2)
    ) {
      return "HR manager has approved your timesheet";
    }

    // Check for project date validation
    const dateValidationTooltip = getDateValidationTooltip(day);
    if (dateValidationTooltip) {
      return dateValidationTooltip;
    }

    // Check for zero allocated hours
    const zeroAllocatedTooltip = getZeroAllocatedTooltip(day);
    if (zeroAllocatedTooltip) {
      return zeroAllocatedTooltip;
    }

    return "";
  };

  return (
    <TableRow>
      <TableCell
        align="left"
        style={{ ...bgCellStyle, paddingLeft: "10px", whiteSpace: "nowrap" }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%"
          }}
        >
          <span>{label}</span>

          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {clientIndex !== -2 && (
              <Tooltip
                arrow
                placement="right"
                title={
                  <>
                    <h6 style={{ margin: "5px 0" }}>Allocated Hours</h6>
                    <table
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "5px",
                              textAlign: "left"
                            }}
                          >
                            Date
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "5px",
                              textAlign: "left"
                            }}
                          >
                            Hours
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formattedData && formattedData.length > 0 ? (
                          formattedData.map((item, index) => (
                            <tr key={index}>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "5px"
                                }}
                              >
                                {item.date}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "5px"
                                }}
                              >
                                {item.allocated_hours}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={2}
                              style={{
                                border: "1px solid white",
                                padding: "5px",
                                textAlign: "center"
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </>
                }
              >
                <IconButton style={{ padding: 0 }}>
                  <AllocatedIcon />
                </IconButton>
              </Tooltip>
            )}

            {tooltipTitle && (
              <Tooltip title={tooltipTitle} arrow>
                <InfoOutlinedIcon
                  sx={{
                    fontSize: 18,
                    color: "#4a5568",
                    cursor: "pointer"
                  }}
                />
              </Tooltip>
            )}
          </span>
        </span>
      </TableCell>

      {data.map((day, idx) => (
        <>
          <TableCell
            align="center"
            key={`input-${idx}`}
            style={{
              ...cellStyle,
              border: errors[`${idx}-${clientIndex}`]?.length
                ? "1px solid red"
                : "1px solid #8E97A7",
              backgroundColor: errors[`${idx}-${clientIndex}`]?.length
                ? "#FFF2F4"
                : !isDateWithinProjectDates(day) ||
                  (day.date_str &&
                    (day.date_str.includes("Sun") ||
                      day.date_str.includes("Sat")) &&
                    isFlexRow)
                ? false
                : isDisabledByAllocatedHours(day)
                ? "#f5f5f5"
                : "white"
            }}
          >
            <Tooltip title={getTooltipMessage(day, idx, clientIndex)} arrow>
              <span>
                <input
                  type="text"
                  placeholder="00:00"
                  value={day.filledTime}
                  onChange={(e) => {
                    const formattedValue = formatTimeInput(e.target.value);
                    updateTimesheetRows(idx, clientIndex, formattedValue);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && day.filledTime.length === 1) {
                    }
                  }}
                  style={{
                    ...inputStyle,
                    backgroundColor: "transparent",
                    cursor:
                      !isDateWithinProjectDates(day) ||
                      (day.date_str &&
                      (day.date_str.includes("Sun") ||
                        day.date_str.includes("Sat")) &&
                      isFlexRow
                        ? false
                        : isDisabledByAllocatedHours(day))
                        ? "not-allowed"
                        : "text",
                    color:
                      !isDateWithinProjectDates(day) ||
                      (day.date_str &&
                      (day.date_str.includes("Sun") ||
                        day.date_str.includes("Sat")) &&
                      isFlexRow
                        ? false
                        : isDisabledByAllocatedHours(day))
                        ? "#999"
                        : "inherit"
                  }}
                  disabled={
                    (!isFlexRow &&
                      (day.date_str?.includes("Sun") ||
                        day.date_str?.includes("Sat")) &&
                      day.allocated === "00:00") ||
                    day.timesheetStatus === TIMESHEET_STATUS.approved ||
                    (isFlexService
                      ? false
                      : (clientIndex === -1 || clientIndex === -2) &&
                        (idx === 0 ||
                          idx === 6 ||
                          timesheetRows.unplannedTimesheetStatus ===
                            TIMESHEET_STATUS.approved)) ||
                    !isDateWithinProjectDates(day) ||
                    ((day.date_str?.includes("Sun") ||
                      day.date_str?.includes("Sat")) &&
                    isFlexRow
                      ? false
                      : isDisabledByAllocatedHours(day))
                  }
                />
              </span>
            </Tooltip>
          </TableCell>
        </>
      ))}
      <Tooltip
        title={
          shouldTimeoffCommentDisable && clientIndex === -2
            ? "Please enter time-off hours before adding a comment"
            : ""
        }
        arrow
        placement="left"
      >
        <TableCell
          align="center"
          style={{
            ...cellStyle,
            border: commentErr ? "1px solid red" : "1px solid #8E97A7",
            backgroundColor: commentErr ? "#FFF2F4" : "white"
          }}
        >
          <TextField
            size="small"
            variant="outlined"
            fullWidth
            multiline
            InputProps={{
              style: { fontSize: "14px", overflow: "hidden" },
              disableUnderline: true
            }}
            onChange={(e) => {
              const { value } = e.target;
              setTimeoffComment(value);
            }}
            disabled={shouldTimeoffCommentDisable}
            placeholder={
              clientIndex === -1
                ? "Enter here*"
                : clientIndex === -2
                ? "Enter here*"
                : ""
            }
            value={timeoffComment}
            sx={{
              "& .MuiInputBase-root": {
                overflow: "hidden !important"
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none"
              },
              "& textarea": {
                overflow: "hidden !important",
                resize: "none"
              }
            }}
          />
        </TableCell>
      </Tooltip>
    </TableRow>
  );
};

const tableCellStyle = {
  border: "1px solid #8E97A7",
  padding: "5px",
  backgroundColor: "#e6e8ed",
  fontWeight: 600,
  fontSize: "13px",
  lineHeight: "100%",
  letterSpacing: "0%",
  color: "black",
  boxShadow: "none",
  borderRadius: "0"
};

const inputStyle = {
  width: "50px",
  border: "none",
  outline: "none",
  textAlign: "center",
  fontSize: "13px"
};

const cellStyle = {
  border: "1px solid #8E97A7",
  padding: "2px"
};

const bgCellStyle = {
  ...cellStyle,
  backgroundColor: "#ebf0f4",
  color: "#797979",
  paddingLeft: "10px",
  paddingRight: "10px"
};
const labelStyle = {
  fontWeight: 500,
  fontSize: "13px",
  color: "black"
};

const valueStyle = {
  fontWeight: 600,
  fontSize: "13px",
  color: "black"
};

const dividerStyle = {
  mx: 1,
  fontWeight: 600,
  fontSize: "13px",
  color: "#BBC2C9"
};
const boxStyle = {
  backgroundColor: "#FAFAFA",
  border: "1px solid #C8CFD5",
  borderRadius: "4px",
  padding: "10px",
  width: "fit-content",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "20px"
};

const recallBoxStyle = {
  backgroundColor: "#FFF9E9",
  border: "1px solid #B38A22",
  borderRadius: "4px",
  padding: "5px",
  width: "fit-content",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "10px"
};
